import React, { useState, useEffect } from 'react'
import { Card, CardBody, Row, Col, Label, Button, Alert } from "reactstrap";
import TextBox from './TextBox';
import { urlObtenerFormulario } from '../../constants/urls';
import Select from './Select';
import Textarea from './TextArea';
import Checkbox from './Checkbox';
import Rango from './Rango';
import SiNo from './SiNo';
import * as Yup from 'yup';
import moment from 'moment';


const Formulario = ({
  codigoFormulario,
  onSubmit,
  onChange,
  onChangeTitulos,
  values,
  setValuesInicial,
  nuevoCarrito,
  valuesConTitulo,
  setValuesConTitulo,
  setLoading,
  anchoPagina,
  bloqueoListaNegra,
  mensajeListaNegra,
  esRenovacion = false

}) => {

  const [inputs, setInputs] = useState([]);
  const [validate, setValidate] = useState(false);
  const [grupos, setGrupos] = useState([]);
  const [datosFormulario, setDatosFormulario] = useState(null)
  const [tieneErrores, setTieneErrores] = useState(null)
  const [validacionYup, setValidacionYup] = useState(false)
  const [erroresYup, setErroresYup] = useState(false)
  const [schema, setSchema] = useState(null)



  useEffect(() => {
    obtenerInformacionFormulario(codigoFormulario)

  }, [codigoFormulario])

  useEffect(() => {

    for (const key in values) {

      const element = values[key];

      const jsonErrores = tieneErrores

      const inputEncontrado = inputs.find(inp => inp.id === key)

      if (inputEncontrado) {
        if (inputEncontrado.required && (element == '' || element == null)) {
          jsonErrores[key] = true
        } else {
          jsonErrores[key] = false
        }
      }

      setTieneErrores(jsonErrores)



    }

  }, [values])

  /**
   * Obtiene la información del formulario 
   * @param {String} codigoFormulario código del formulario 
   */
  const obtenerInformacionFormulario = async (codigoFormulario) => {

    var url = `${urlObtenerFormulario}${codigoFormulario}`;

    try {
      const response = await fetch(url)
      const json = await response.json()
      if (json.transaccion) {

        const valores = {}
        const valoresValidaciones = {}
        json.formulario.inputs.forEach(element => {


          if (element.type != 'input') {
            valores[element.id] = element.value == '' ? null : element.value
            valoresValidaciones[element.id] = element.required ? true : false
          }


        });


        setTieneErrores(valoresValidaciones)
        if (!validacionYup || nuevoCarrito) {
          setValuesInicial(valores)
        }
        setDatosFormulario(json.formulario)
        setGrupos(ordenar(json.formulario.grupos, 'orden'))
        setInputs(json.formulario.inputs)

        //controlar validacion con YUP
        setValidacionYup(json.formulario.yupValidations)


        setSchema((json.formulario.schema))
      }

    } catch (error) {
    }
  }


  const getSchema = (schemaString) => {


    return (

      Yup.object(



        parseSchema(Yup, schemaString, moment)


      )

    )

  }







  function parseSchema(Yup, schemaString, moment) {
    try {
      // Evaluamos la cadena de texto, pero esta vez usando una sintaxis segura
      const schema = eval('(' + schemaString + ')');  // evalúa el string como código

      return schema;
    } catch (error) {
      console.error('Error al convertir el esquema:', error);
      return null;
    }


  }


  function consolidateChildKeys(inputData) {
    const result = {};

    for (const key in inputData) {
      const [parentKey, childKey] = key.split('.'); // Dividir clave en padre e hijo

      if (childKey) {
        // Si es una clave hija, consolidar en el padre
        result[parentKey] = inputData[key];
      } else if (!(parentKey in result)) {
        // Si es una clave padre y aún no está consolidada, agregarla
        result[parentKey] = inputData[key];
      }
    }

    return result;
  }



  const validateForm = async (values) => {


    try {
      await getSchema(schema).validate(values, { abortEarly: false });
      setErroresYup({});
      return true;
    } catch (err) {


      const newErrors = {};
      err.inner.forEach((error) => {
        newErrors[error.path] = error.message;
      });

      console.log('newErrors', consolidateChildKeys(newErrors))



      setErroresYup(consolidateChildKeys(newErrors));
      return false;
    }
  };

  const ordenar = (array, key) => {
    return array.sort(function (a, b) {
      var x = a[key]; var y = b[key];
      return ((x < y) ? -1 : ((x > y) ? 1 : 0));
    });
  }

  const obtenerInputsPorGrupo = (idGrupo) => {
    const arrayFiltrado = inputs.filter(array => array.grupo == idGrupo)
    return ordenar(arrayFiltrado, 'orden')
  }

  return (
    <Row>
      {datosFormulario ?
        <Col lg={anchoPagina ? anchoPagina : 12} md={12} sm={12} xs={12} className="div-align-center">
          <Card className="flex-row ">
            <CardBody>

              <Row>
                {grupos.map(({ id, label, orden, mostrarTitulo, separadorInferior }) => {
                  return (
                    <React.Fragment key={id + "grupo"}>
                      {mostrarTitulo &&
                        <h4 style={{ fontWeight: "bold" }} className="mb-5">
                          {" "}
                          {label}
                        </h4>
                      }

                      {obtenerInputsPorGrupo(id).map(({ id,
                        name,
                        type,
                        placeholder,
                        value,
                        label,
                        icono,
                        maxLength,
                        minLength,
                        length,
                        required,
                        reg,
                        mensajeError,
                        isSearchable,
                        valuesSelect,
                        valueSelect,
                        peticiones,
                        padre,
                        min,
                        max,
                        edadMaxima,
                        edadMinima,
                        disabled,
                        leyenda,
                        fechaInicioMinimoDias,
                        fechaRangoMaximoDias
                      }, i) => {

                        return (
                          <Col md={esRenovacion ? (type == 'input' ? 2 : 5) : 12} key={id}>
                            {(type == 'text' || type == 'number' || type == 'date') && <Row>
                              <Col lg={4} md={4} sm={12} xs={12} className="ml-3">
                                <h5>
                                  <Label className="bold-font-label">{label}  </Label>
                                  <Label>

                                  </Label>

                                </h5>
                              </Col>
                              <Col lg={7} md={7} sm={12} xs={12}>
                                <Col lg={12} md={12} sm={12} xs={12}>

                                  <TextBox
                                    id={id}
                                    type={type}
                                    edadMaxima={edadMaxima}
                                    edadMinima={edadMinima}
                                    disabled={disabled}
                                    value={values[id]}
                                    valorTipoDocumento={values['tipoIdentificacion']}
                                    values={valuesSelect}
                                    name={name}
                                    validate={validate}
                                    maxLength={maxLength}
                                    minLength={minLength}
                                    length={length}
                                    reg={reg}
                                    hasError={tieneErrores[id]}
                                    esDependiente={padre == null ? false : true}
                                    codPadre={padre == null ? null : padre}
                                    valorPadre={padre == null ? null : values[padre] ? values[padre].value : null}
                                    mensajeError={mensajeError}
                                    required={required}
                                    placeholder={placeholder}
                                    min={min}
                                    validacionYup={validacionYup}
                                    mensajeErrorYup={erroresYup[id]}
                                    max={max}
                                    onChange={(valor) => {


                                      var objeto = { ...values }
                                      objeto[id] = valor;

                                      if (validacionYup) {
                                        validateForm(objeto)
                                      }
                                      onChange(id, objeto)

                                      var objetoTitulos = { ...valuesConTitulo, [id]: { label: label, value: valor, tipo: type } }
                                      if (typeof onChangeTitulos === "function") {
                                        onChangeTitulos(id, objetoTitulos)
                                      }

                                    }}
                                    validationCallback={(valor) => {

                                      var objeto = { ...tieneErrores }
                                      objeto[id] = valor;
                                      setTieneErrores(objeto)
                                    }}
                                  />


                                  {
                                    leyenda &&
                                    <div style={{ marginTop: '40' }}>
                                      <small>{leyenda}</small>
                                    </div>
                                  }

                                </Col>
                              </Col>
                            </Row>
                            }

                            {(type == 'rango') && <Row>
                              <Col lg={4} md={4} sm={12} xs={12} className="ml-3">
                                <h5>

                                  <Label className="bold-font-label">{label} </Label>
                                </h5>
                              </Col>
                              <Col lg={7} md={7} sm={12} xs={12}>
                                <Col lg={12} md={12} sm={12} xs={12}>

                                  <Rango
                                    value={values[id]}
                                    validacionYup={validacionYup}
                                    mensajeErrorYup={erroresYup[id]}
                                    fechaInicioMinimoDias={fechaInicioMinimoDias}
                                    fechaRangoMaximoDias={fechaRangoMaximoDias}
                                    onChange={(valor) => {
                                      var objeto = { ...values }
                                      objeto[id] = valor;

                                      if (validacionYup) {


                                        validateForm(objeto)


                                      }

                                      onChange(id, objeto)


                                      var objetoTitulos = { ...valuesConTitulo, [id]: { label: label, value: valor, tipo: type } }
                                      if (typeof onChangeTitulos === "function") {
                                        onChangeTitulos(id, objetoTitulos)
                                      }
                                    }}

                                    validationCallback={(valor) => {



                                      var objeto = { ...tieneErrores }
                                      objeto[id] = valor;
                                      console.log('valorVer', objeto)
                                      setTieneErrores(objeto)
                                    }}
                                  />

                                </Col>
                              </Col>
                            </Row>
                            }

                            {(type == 'checkbox') && <Row>
                              <Col lg={4} md={4} sm={12} xs={12} className="ml-3">
                                <h5>
                                  <Label className="bold-font-label">{label} </Label>
                                </h5>
                              </Col>
                              <Col lg={7} md={7} sm={12} xs={12}>
                                <Col lg={12} md={12} sm={12} xs={12}>

                                  <Checkbox
                                    id={id}
                                    type={type}
                                    value={values[id]}
                                    name={name}
                                    validate={validate}
                                    maxLength={maxLength}
                                    minLength={minLength}
                                    length={length}
                                    reg={reg}
                                    hasError={tieneErrores[id]}
                                    mensajeError={mensajeError}
                                    required={required}
                                    placeholder={placeholder}
                                    min={min}
                                    max={max}
                                    onChange={(valor) => {

                                      var objeto = { ...values }
                                      objeto[id] = valor;


                                      onChange(id, objeto)

                                      var objetoTitulos = { ...valuesConTitulo, [id]: { label: label, value: valor, tipo: type } }
                                      if (typeof onChangeTitulos === "function") {
                                        onChangeTitulos(id, objetoTitulos)
                                      }
                                    }}
                                    validationCallback={(valor) => {

                                      var objeto = { ...tieneErrores }
                                      objeto[id] = valor;
                                      setTieneErrores(objeto)
                                    }}
                                  />

                                </Col>
                              </Col>
                            </Row>
                            }

                            {(type == 'select') && <Row>
                              <Col lg={4} md={4} sm={12} xs={12} className="ml-3">
                                <h5>
                                  <Label className="bold-font-label">{label} </Label>


                                </h5>
                              </Col>
                              <Col lg={7} md={7} sm={12} xs={12}>
                                <Col lg={12} md={12} sm={12} xs={12}>



                                  <Select
                                    id={id}
                                    type={type}
                                    validate={validate}
                                    value={values[id]}
                                    valueSelect={valueSelect}
                                    name={name}
                                    setLoading={(value) => { setLoading(value) }}
                                    maxLength={maxLength}
                                    values={valuesSelect}
                                    minLength={minLength}
                                    disabled={disabled}
                                    length={length}
                                    reg={reg}
                                    mensajeError={mensajeError}
                                    required={required}
                                    placeholder={placeholder}
                                    isSearchable={isSearchable}
                                    peticiones={peticiones}
                                    esDependiente={padre == null ? false : true}
                                    codPadre={padre == null ? null : padre}
                                    valorPadre={padre == null ? null : values[padre] ? values[padre].value : null}
                                    hasError={tieneErrores[id]}
                                    validacionYup={validacionYup}
                                    mensajeErrorYup={erroresYup[id]}
                                    onChange={(valor) => {



                                      var objeto = { ...values }
                                      objeto[id] = valor;

                                      onChange(id, objeto)

                                      if (validacionYup) {


                                        validateForm(objeto)


                                      }




                                      switch (id) {
                                        case 'tipoIdentificacion':
                                          objeto["identificacion"] = null;
                                          break;

                                        case 'provincia':
                                          objeto["ciudad"] = {};
                                          break;
                                      }


                                      var objetoTitulos = { ...valuesConTitulo, [id]: { label: label, value: valor, tipo: type } }

                                      if (typeof onChangeTitulos === "function") {
                                        onChangeTitulos(id, objetoTitulos)
                                      }


                                    }}
                                    validationCallback={(valor) => {

                                      var objeto = { ...tieneErrores }
                                      objeto[id] = valor;
                                      setTieneErrores(objeto)
                                    }}
                                  />

                                </Col>
                              </Col>
                            </Row>
                            }

                            {(type == 'SiNo') && <Row>
                              <Col lg={4} md={4} sm={12} xs={12} className="ml-3">
                                <h5>
                                  <Label className="bold-font-label">{label} </Label>
                                </h5>
                              </Col>
                              <Col lg={7} md={7} sm={12} xs={12}>
                                <Col lg={12} md={12} sm={12} xs={12}>



                                  <SiNo
                                    id={id}
                                    type={type}
                                    validate={validate}
                                    value={values[id]}
                                    valueSelect={valueSelect}
                                    name={name}
                                    setLoading={(value) => { setLoading(value) }}
                                    maxLength={maxLength}
                                    values={valuesSelect}
                                    minLength={minLength}
                                    disabled={disabled}
                                    length={length}
                                    reg={reg}
                                    mensajeError={mensajeError}
                                    required={required}
                                    placeholder={placeholder}
                                    isSearchable={isSearchable}
                                    peticiones={peticiones}
                                    esDependiente={padre == null ? false : true}
                                    codPadre={padre == null ? null : padre}
                                    valorPadre={padre == null ? null : values[padre] ? values[padre].value : null}
                                    hasError={tieneErrores[id]}
                                    onChange={(valor) => {
                                      var objeto = { ...values }
                                      objeto[id] = valor;

                                      onChange(id, objeto)



                                      var objetoTitulos = { ...valuesConTitulo, [id]: { label: label, value: valor, tipo: type } }

                                      if (typeof onChangeTitulos === "function") {
                                        onChangeTitulos(id, objetoTitulos)
                                      }


                                    }}
                                    validationCallback={(valor) => {

                                      var objeto = { ...tieneErrores }
                                      objeto[id] = valor;
                                      setTieneErrores(objeto)
                                    }}
                                  />

                                </Col>
                              </Col>
                            </Row>
                            }

                            {(type == 'textarea') && <Row>
                              <Col lg={4} md={4} sm={12} xs={12} className="ml-3">
                                <h5>
                                  <Label className="bold-font-label">{label} </Label>
                                </h5>
                              </Col>
                              <Col lg={7} md={7} sm={12} xs={12}>
                                <Col lg={12} md={12} sm={12} xs={12}>

                                  <Textarea
                                    id={id}
                                    type={type}
                                    hasError={tieneErrores[id]}
                                    value={values[id]}
                                    name={name}
                                    validate={false}
                                    maxLength={maxLength}
                                    minLength={minLength}
                                    length={length}
                                    reg={reg}
                                    mensajeError={mensajeError}
                                    required={required}
                                    placeholder={placeholder}
                                    validacionYup={validacionYup}
                                    mensajeErrorYup={erroresYup[id]}
                                    onChange={(valor) => {
                                      var objeto = { ...values }
                                      objeto[id] = valor;

                                      if (validacionYup) {


                                        validateForm(objeto)


                                      }

                                      onChange(id, objeto)

                                      var objetoTitulos = { ...valuesConTitulo, [id]: { label: label, value: valor, tipo: type } }
                                      if (typeof onChangeTitulos === "function") {
                                        onChangeTitulos(id, objetoTitulos)
                                      }
                                    }}
                                    validationCallback={(valor) => {

                                      var objeto = { ...tieneErrores }
                                      objeto[id] = valor;
                                      setTieneErrores(objeto)
                                    }}
                                  />

                                </Col>
                              </Col>
                            </Row>
                            }

                            {(type == 'input') &&

                              <Row>
                                <div className="div-align-rigth">
                                  <Button
                                    className="btn btn-primary"
                                    onClick={async () => {






                                      if (validacionYup) {



                                        let validador = await validateForm(values)

                                        if (validador) {
                                          onSubmit(values, false, false, valuesConTitulo)
                                        }

                                        return false

                                      }

                                      setValidate(!validate)

                                      // return console.log('validacionYup', tieneErroresAux)




                                      var tieneErroresAux = false


                                      for (const key in tieneErrores) {
                                        const element = tieneErrores[key];

                                        if (element == true) {
                                          tieneErroresAux = true
                                        }
                                      }






                                      onSubmit(values, tieneErroresAux, tieneErrores, valuesConTitulo)
                                    }
                                    }
                                    style={{ display: "block", margin: "auto" }}
                                  >
                                    <i
                                      className={icono}
                                      aria-hidden="true"
                                    />{" "}
                                    {label}
                                  </Button>
                                </div>
                              </Row>
                            }


                          </Col>
                        )

                      })}

                      {separadorInferior &&
                        <hr></hr>
                      }



                    </React.Fragment>


                  )
                })}

              </Row>


              {bloqueoListaNegra
                ?
                <div>
                  <br></br>
                  <Alert color="danger">
                    <center><p>{mensajeListaNegra}</p></center>
                  </Alert>
                </div>

                :
                null
              }
            </CardBody>

          </Card>
        </Col> : null}




    </Row>
  );
};

export default Formulario;
